<template>
  <ol-map v-if="isLoading" :controls="[]" style="height: 100%" :projection="projection">
    <ol-view :center="center" :zoom="zoom" :projection="projection" />

    <ol-tile-layer className="dts-background-map">
      <ol-source-osm />
    </ol-tile-layer>

    <ol-zoom-control className="ol-zoom" zoomInLabel="+" zoomOutLabel="-" />

    <InteractionSelect
      :sensorReadings="sensorReadings"
      :vessels="filteredVessels"
    ></InteractionSelect>

    <Vessels :is-visible="isVesselActive" :vessel-data="filteredVessels" />
    <CableAcoustics
      :sensorReadings="sensorReadings.filter((x) => x.das !== null)"
      :isVisible="isDASActive"
    ></CableAcoustics>
    <CableTemperature :sensorReadings="sensorReadings" :isVisible="isDTSActive" />
    <CableDepthofBurial :sensorReadings="sensorReadings" :isVisible="isDoBActive" />
    <Cable :sensorReadings="sensorReadings" :isVisible="true" />
    <Points :sensorReadings="sensorReadings" :isVisible="false" />
    <PopupMap :isVisible="true" :cableLength="cableLength"></PopupMap>
  </ol-map>
</template>

<script setup lang="ts">
import { ref, computed, defineProps, PropType } from 'vue'
import { useFilterStore } from '@/stores/HomeFilterStore'
import Points from './Points.vue'
import { MapCableDataPoint, CableVessel } from '@/server/MakeSenseApp-backend'
import Cable from './Cable.vue'
import CableDepthofBurial from './CableDepthofBurial.vue'
import CableTemperature from './CableTemperature.vue'
import CableAcoustics from './CableAcoustics.vue'
import Vessels from './Vessels.vue'
import InteractionSelect from './InteractionSelect.vue'
import PopupMap from './PopupMap.vue'

const projection = ref('EPSG:3857')
const zoom = ref(9)
const isLoading = ref(true)

var props = defineProps({
  sensorReadings: {
    type: Array as PropType<MapCableDataPoint[]>,
    required: true
  },
  vessels: {
    type: Array as PropType<CableVessel[]>,
    required: true
  },
  center: Array<Number>,
  cableLength: Number
})

const filterStore = useFilterStore()

const isDTSActive = computed(() => filterStore.isDTSActive)
const isDoBActive = computed(() => filterStore.isDoBActive)
const isDASActive = computed(() => filterStore.isDASActive)
const isVesselActive = computed(() => filterStore.isVesselActive)

const isFishingActive = computed(() => filterStore.isFishingActive)
const isCargoActive = computed(() => filterStore.isCargoActive)
const isTankerActive = computed(() => filterStore.isTankerActive)
const isUnderwaterActive = computed(() => filterStore.isUnderwaterActive)
const isDivingActive = computed(() => filterStore.isDivingActive)
const isPassengerActive = computed(() => filterStore.isPassengerActive)
const isOtherActive = computed(() => filterStore.isOtherActive)
const isUnknownActive = computed(() => filterStore.isUnknownActive)

const filteredVessels = computed(() => {
  return props.vessels.filter((vessel) => {
    if (isFishingActive.value && vessel.vesselType === 0) {
      return true
    }

    if (isCargoActive.value && vessel.vesselType === 1) {
      return true
    }

    if (isTankerActive.value && vessel.vesselType === 2) {
      return true
    }

    if (isUnderwaterActive.value && vessel.vesselType === 3) {
      return true
    }

    if (isDivingActive.value && vessel.vesselType === 4) {
      return true
    }

    if (isPassengerActive.value && vessel.vesselType === 5) {
      return true
    }

    if (isUnknownActive.value && vessel.vesselType === 6) {
      return true
    }

    if (isOtherActive.value && vessel.vesselType === 7) {
      return true
    }

    return false
  })
})
</script>

<style>
.ol-map {
  position: relative;
  width: 100%;
  height: 100%;
}

.dts-background-map {
  filter: grayscale(100%);
}

.ol-zoom {
  right: 16px;
  bottom: 20px;
  left: auto !important;
  top: auto !important;
  transform: scale(1.5);
}
</style>
